import * as React from 'react';
import { SVGProps } from 'react';

const IconRestartSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3.853 2.36 2.5.5 1 6h5.5L5.03 3.978A5.002 5.002 0 0 1 12.9 7h2.028A7 7 0 0 0 3.853 2.36zm-1.569 9.68A7 7 0 0 1 1.072 9H3.1a5.002 5.002 0 0 0 7.87 3.022L9.5 10H15l-1.5 5.5-1.353-1.86a6.998 6.998 0 0 1-9.864-1.6z" />
  </svg>
);
export default IconRestartSizeS;
